import { __extends } from "tslib";
import { AxesViewer } from "../Debug/axesViewer";
import { Vector3 } from "../Maths/math.vector";
import { Axis } from '../Maths/math.axis';
/**
     * The BoneAxesViewer will attach 3 axes to a specific bone of a specific mesh
     * @see demo here: https://www.babylonjs-playground.com/#0DE8F4#8
     */
var BoneAxesViewer = /** @class */ (function (_super) {
    __extends(BoneAxesViewer, _super);
    /**
     * Creates a new BoneAxesViewer
     * @param scene defines the hosting scene
     * @param bone defines the target bone
     * @param mesh defines the target mesh
     * @param scaleLines defines a scaling factor for line length (1 by default)
     */
    function BoneAxesViewer(scene, bone, mesh, scaleLines) {
        if (scaleLines === void 0) { scaleLines = 1; }
        var _this = _super.call(this, scene, scaleLines) || this;
        /** Gets current position */
        _this.pos = Vector3.Zero();
        /** Gets direction of X axis */
        _this.xaxis = Vector3.Zero();
        /** Gets direction of Y axis */
        _this.yaxis = Vector3.Zero();
        /** Gets direction of Z axis */
        _this.zaxis = Vector3.Zero();
        _this.mesh = mesh;
        _this.bone = bone;
        return _this;
    }
    /**
     * Force the viewer to update
     */
    BoneAxesViewer.prototype.update = function () {
        if (!this.mesh || !this.bone) {
            return;
        }
        var bone = this.bone;
        bone._markAsDirtyAndCompose();
        bone.getAbsolutePositionToRef(this.mesh, this.pos);
        bone.getDirectionToRef(Axis.X, this.mesh, this.xaxis);
        bone.getDirectionToRef(Axis.Y, this.mesh, this.yaxis);
        bone.getDirectionToRef(Axis.Z, this.mesh, this.zaxis);
        _super.prototype.update.call(this, this.pos, this.xaxis, this.yaxis, this.zaxis);
    };
    /** Releases resources */
    BoneAxesViewer.prototype.dispose = function () {
        if (this.mesh) {
            this.mesh = null;
            this.bone = null;
            _super.prototype.dispose.call(this);
        }
    };
    return BoneAxesViewer;
}(AxesViewer));
export { BoneAxesViewer };
//# sourceMappingURL=boneAxesViewer.js.map